import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
    wrapper,
    changeBox,
    changeButton,
    content,
    dropdown,
    replacementButton,
    replacement,
    simple,
    aiButton,
} from './recipe-ingredient.module.scss';
import ArrowIcon from '../../../assets/images/svg/down-arrow.svg';
import ChangeIcon from '../../../assets/images/svg/change.svg';
import { sortAlphabeticallyByKey } from '../../../utills/sort-alphabetically-by-key';
import { roundQuantityForDisplay } from '../../../utills/round-quantity-for-display';

import Button from '../button';
import Dropdown from '../../molecules/dropdown';

const RecipeIngredient = ({ ingredient, multiplier, onIngredientChange, onAiSwap, simpleView }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const hasReplacement = ingredient.replacements && ingredient.replacements.length > 0;

    const handleReplace = (replacementId) => {
        setDropdownOpen(false);
        if (typeof onIngredientChange === 'function') {
            onIngredientChange(ingredient.id, replacementId);
        }
    };

    const getQuantity = () => {
        return roundQuantityForDisplay(ingredient.quantity * multiplier, ingredient.unit);
    };

    return (
        <li
            className={`
                ${wrapper} 
                ${hasReplacement ? replacement : ''}
                ${simpleView ? simple : ''}
            `}
        >
            <div className={content}>
                {getQuantity()}
                &nbsp;
                {ingredient.unit}
                {` `}
                {ingredient.name}
            </div>
            {hasReplacement && (
                <div className={changeBox}>
                    <Button
                        color="black"
                        className={changeButton}
                        icon={ArrowIcon}
                        size="small"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                    >
                        Zmień
                    </Button>
                    <Dropdown
                        className={dropdown}
                        open={dropdownOpen}
                        closeFunc={() => setDropdownOpen(false)}
                    >
                        {sortAlphabeticallyByKey(ingredient.replacements, 'name').map(
                            (replacement) => (
                                <button
                                    key={`replacement-${replacement.id}`}
                                    className={replacementButton}
                                    onClick={() => handleReplace(replacement.id)}
                                >
                                    {replacement.name}
                                </button>
                            )
                        )}
                    </Dropdown>
                </div>
            )}
            {typeof onAiSwap === 'function' && (
                <Button
                    color="yellow"
                    className={aiButton}
                    icon={ChangeIcon}
                    size="small"
                    title="Zaproponuj zamiennik (AI)"
                    onClick={() => onAiSwap(ingredient)}
                />
            )}
        </li>
    );
};

RecipeIngredient.propTypes = {
    ingredient: PropTypes.object.isRequired,
    multiplier: PropTypes.number,
    onIngredientChange: PropTypes.func,
    onAiSwap: PropTypes.func,
    simpleView: PropTypes.bool,
};

RecipeIngredient.defaultProps = {
    multiplier: 1,
    onIngredientChange: null,
    onAiSwap: null,
    simpleView: false,
};

export default RecipeIngredient;
